







































































import {
  computed,
  defineComponent,
  onMounted,
  Ref,
  ref,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';

import useAxios from '@/useAxios';
import {
  deleteFileConfig,
  getConfigs,
  updateWebsiteConfig,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const Live = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
  },
  setup() {
    const { axios } = useAxios();
    const moduleName = 'live';
    const successModal = ref(null);
    const features: Ref<any> = ref({});
    const textConfigs: Ref<any> = ref({});
    const images: Ref<any> = ref({});

    const computedTextConfigsInput = computed(() => {
      const result = {};
      Object.entries(textConfigs.value).forEach(([key, value]: any[]) => {
        (result as any)[key] = value.value;
      });
      return result;
    });
    const computedFeatureInput = computed(() => {
      const result = {};
      Object.entries(features.value).forEach(([key, value]: any[]) => {
        (result as any)[key] = value.value;
      });
      return result;
    });

    async function callUpdateWebsiteConfig(data: any) {
      const result = await updateWebsiteConfig(data, moduleName);
      if (result !== '') {
        features.value = (result as any).features as any;
        textConfigs.value = (result as any).textConfigs as any;
        images.value = (result as any).images as any;
        (successModal.value as any).compose({ action: 'แก้ไข', entity: 'การตั้งค่า เรียบร้อย' });
      }
    }
    async function submitTextConfigs() {
      await callUpdateWebsiteConfig(computedTextConfigsInput.value);
    }
    async function submitUpdateConfig() {
      await callUpdateWebsiteConfig(computedFeatureInput.value);
    }

    async function updateConfig(name: string, status: boolean) {
      (features.value as any)[name].value = !status;
    }

    const loading = ref(false);
    async function callGetConfigs(force = false) {
      loading.value = true;
      const res = await getConfigs(moduleName, force);
      features.value = (res as any).features as any;
      textConfigs.value = (res as any).textConfigs as any;
      images.value = (res as any).images as any;
      loading.value = false;
    }
    onMounted(async () => {
      await callGetConfigs();
    });

    async function uploadDone() {
      await callGetConfigs(true);
    }
    const deleteConfigImageModal = ref(null);
    async function deleteConfigImageAction(ctx: { key: string }) {
      await deleteFileConfig(ctx.key, moduleName);
      await callGetConfigs();
    }
    const openDeleteConfigImageModal = (key: string) => {
      (deleteConfigImageModal.value as any).compose({ key, action: 'ลบ', entity: 'รูปภาพ' });
    };

    return {
      successModal,
      loading,
      axios,

      updateConfig,

      images,
      features,
      textConfigs,

      uploadDone,
      submitTextConfigs,
      submitUpdateConfig,

      deleteConfigImageModal,
      deleteConfigImageAction,
      openDeleteConfigImageModal,
    };
  },
});

export default Live;
